"use client";
import Image, { StaticImageData } from "next/image";
import { motion } from "framer-motion";

type SectionTitleProps = {
  title1: string;
  title2: string;
  leftIcon?: string | StaticImageData;
  rightIcon?: string | StaticImageData;
  iconSizeLeft?: number;
  iconSizeRight?: number;
  hideIconOnMobile?: "left" | "right";
};

export default function SectionTitle({
  title1,
  title2,
  leftIcon,
  rightIcon,
  iconSizeLeft = 150,
  iconSizeRight = 150,
  hideIconOnMobile,
}: SectionTitleProps) {
  const hideLeft = hideIconOnMobile === "left";
  const hideRight = hideIconOnMobile === "right";

  return (
    <div className="flex items-center justify-center gap-3 flex-wrap">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="flex items-center sm:gap-4 justify-center"
      >
        {leftIcon && (
          <Image
            src={leftIcon}
            alt=""
            width={iconSizeLeft}
            height={iconSizeLeft}
            // nascosta SOLO su mobile quando richiesto
            className={hideLeft ? "hidden sm:inline-block" : undefined}
          />
        )}

        <h2 className="text-4xl font-extrabold pb-4 text-center">
          <span style={{ color: "var(--foreground)" }}>
            {title1}
          </span>
          <span style={{ color: "var(--card-foreground)" }}>
            {title2}
          </span>
        </h2>

        {rightIcon && (
          <Image
            src={rightIcon}
            alt=""
            width={iconSizeRight}
            height={iconSizeRight}
            className={hideRight ? "hidden sm:inline-block" : undefined}
          />
        )}
      </motion.div>
    </div>
  );
}